"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../generator/utils");

var NPointsCrossover_1 = require("./NPointsCrossover");

var OnePointCrossover =
/** @class */
function () {
  function OnePointCrossover() {}

  OnePointCrossover.prototype.cross = function (firstParent, secondParent, individualConstructor, engine) {
    if (engine === void 0) {
      engine = utils_1.Generator.DEFAULT_ENGINE;
    }

    return this.crossWith(firstParent, secondParent, {
      individualConstructor: individualConstructor,
      engine: engine
    });
  };

  OnePointCrossover.prototype.crossWith = function (firstParent, secondParent, params) {
    var cross = new NPointsCrossover_1.default();
    return cross.crossWith(firstParent, secondParent, {
      engine: params.engine,
      individualConstructor: params.individualConstructor,
      numberOfCrossoverPoints: 1
    });
  };

  return OnePointCrossover;
}();

exports.default = OnePointCrossover;